import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING, STAKE } from "./constants";
import { Backdrop, SceneTitle, glow } from "./shared";

const TABS = [
  { name: "GitHub",     icon: "📦", c: COLORS.neonPurple },
  { name: "Confluence", icon: "📘", c: COLORS.neonBlue },
  { name: "Slack",      icon: "💬", c: COLORS.neonPink },
  { name: "Jira",       icon: "📋", c: COLORS.neonOrange },
  { name: "Drive",      icon: "📁", c: COLORS.neonYellow },
  { name: "ChatGPT",    icon: "🤖", c: COLORS.neonCyan },
];

export const Scene06WorkerProblem: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleAp = interpolate(spring({ frame, fps, config: SPRING.snappy }), [0, 1], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const orbitAngle = frame * 0.015;

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={STAKE.worker} />

      <SceneTitle
        text="The Knowledge Worker"
        subtitle="Six tabs. Zero answers. Every single morning."
        color={STAKE.worker}
        frame={frame}
        appear={titleAp}
      />

      {/* Center: tired worker */}
      <div style={{
        position: "absolute", top: 440, left: "50%",
        transform: "translateX(-50%)",
        width: 240, height: 240,
        zIndex: 10,
      }}>
        <div style={{
          width: "100%", height: "100%",
          borderRadius: "50%",
          background: `radial-gradient(circle at 35% 30%, ${STAKE.worker}66, ${STAKE.worker}15 60%, transparent)`,
          border: `3px solid ${STAKE.worker}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 130,
          boxShadow: `0 0 80px ${STAKE.worker}88, inset 0 0 40px ${STAKE.worker}33`,
        }}>
          😵‍💫
        </div>
      </div>

      {/* 6 orbiting tabs */}
      <div style={{
        position: "absolute", top: 560, left: "50%",
        width: 0, height: 0,
        perspective: 1400,
      }}>
        {TABS.map((t, i) => {
          const sp = spring({ frame: frame - 20 - i * 10, fps, config: SPRING.bouncy });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const scale = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const ang = orbitAngle + (i * Math.PI * 2) / TABS.length;
          const rx = 480, ry = 160;
          const x = Math.cos(ang) * rx;
          const y = Math.sin(ang) * ry;
          const inFront = Math.sin(ang) > 0;
          const depth = inFront ? 1 : 0.75;
          const z = inFront ? 5 : 1;
          return (
            <div key={t.name} style={{
              position: "absolute",
              left: x - 80,
              top: y - 60,
              width: 160,
              height: 120,
              opacity: op * (inFront ? 1 : 0.7),
              transform: `scale(${scale * depth})`,
              zIndex: z,
            }}>
              <div style={{
                width: "100%", height: "100%",
                background: `linear-gradient(135deg, ${t.c}22, ${COLORS.bgCard}ee)`,
                border: `2px solid ${t.c}`,
                borderRadius: 14,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                boxShadow: `0 0 24px ${t.c}77`,
              }}>
                <div style={{ fontSize: 44 }}>{t.icon}</div>
                <div style={{
                  fontSize: 18,
                  fontFamily: FONTS.mono,
                  fontWeight: 700,
                  color: t.c,
                  textShadow: glow(t.c),
                }}>{t.name}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Bottom stat */}
      <div style={{
        position: "absolute", bottom: 70, left: 0, right: 0,
        textAlign: "center",
        opacity: interpolate(spring({ frame: frame - 180, fps, config: SPRING.gentle }), [0, 1], [0, 1], {
          extrapolateLeft: "clamp", extrapolateRight: "clamp",
        }),
      }}>
        <div style={{
          fontSize: 42,
          fontFamily: FONTS.heading,
          fontWeight: 800,
          color: COLORS.neonRed,
          textShadow: glow(COLORS.neonRed, true),
          letterSpacing: -0.5,
        }}>
          1 hour wasted rebuilding context · every morning
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
